import { message, Modal, Progress } from "antd";
import svg from "../../../../Assets/svg";
import { ButtonWithLoader } from "../../../../Components/Components";
import { useRef, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { UploadCSVFileAPI } from "../../../Redux/quiz";
import { alias } from "../../../../helpers/utils";

const BulkUploadQuestionsModal = ({ isModalOpen, onClose }) => {
  const dispatch = useDispatch();
  const uploadInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState([]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");

    if (!isCSV) {
      message.error("Please select a valid CSV file.");
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
  };

  const uploadFileToBackend = async () => {
    if (!selectedFile) {
      message.error("Please select a file to upload first!");
      return;
    }

    try {
      setIsUploading(true);
      setUploadProgress(0);

      const response = await dispatch(
        UploadCSVFileAPI(selectedFile, (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        })
      );

      if (response?.success) {
        setSelectedFile(null);
        setUploadProgress(0);
        setIsFileUploaded(true);

        if (response?.message) {
          setSuccessMessage(response.message);
        }
        if (response?.errorSummary) {
          setErrorMessage(response.errorSummary);
        }

        if (response?.errors?.length > 0) {
          setErrors(response?.errors?.map((error) => error.reason));
        }
      }
      // Reset state after upload
    } catch (err) {
      console.error("Upload failed:", err);
      message.error("Upload failed. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Modal
      title={
        <div className="modal-header border-bottom pb-2 fw-bold fs-4 ff">
          Bulk Upload Questions
        </div>
      }
      open={isModalOpen}
      onCancel={() => {
        onClose(isFileUploaded ? true : false);
      }}
      footer={
        !isFileUploaded &&
        !isUploading && (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <ButtonWithLoader
              type="button"
              className="btn btn-lg btn-primary min-w-124"
              onClick={() => {
                // onEdit(questionId);
                uploadFileToBackend();
              }}
              isLoading={false}
            >
              Upload
            </ButtonWithLoader>
          </div>
        )
      }
      centered
      closeIcon={svg?.modalClose}
      className="custom-modal "
      width={"67.5rem"}
      
      maskClosable={false}
    >
      {isFileUploaded ? (
        <div
          className="rounded-4"
          style={{
            height: "10.5rem",
            backgroundColor: "#E6FFEC",
          }}
        >
          <div className="d-flex align-items-center justify-content-start h-100 ms-3 ff fw-bold gap-3 fs-5">
            <span>{svg.uploadSuccess}</span> CSV uploaded successfully
          </div>
        </div>
      ) : (
        <>
          <div
            className="rounded-4 position-relative"
            style={{
              height: "10.5rem",
              backgroundColor: "#f2f2f2",
              // cursor: uploading ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              if (isUploading) return;
              uploadInputRef.current.value = "";
              uploadInputRef.current?.click();
            }}
          >
            {selectedFile ? (
              <>
                {!isUploading && (
                  <div
                    className="position-absolute top-0 end-0 m-3 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedFile(null);
                    }}
                  >
                    {svg.deleteUploadedFile}
                  </div>
                )}
                <div className="d-flex flex-column align-items-center gap-2 ff position-absolute top-50 start-50 translate-middle">
                  <div>{svg?.uploadedFile}</div>
                  <div className="fs-5">{selectedFile.name}</div>
                </div>
              </>
            ) : (
              <div className="text-center fw-bold fs-6 ff d-flex flex-column position-absolute top-50 start-50 translate-middle">
                <span className="svg-50 mb-3">{svg?.uploadIcon}</span>
                Upload CSV File
              </div>
            )}
            <input
              type="file"
              accept=".csv"
              multiple
              ref={uploadInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>

          {isUploading && (
            <div className="mt-2">
              <Progress
                percent={uploadProgress}
                status={uploadProgress === 100 ? "success" : "active"}
              />
            </div>
          )}

          {/* {isUploading && uploadProgress === 100 && <div>Processing...</div>} */}
          {isUploading && uploadProgress === 100 && (
            <div className="mt-2 ff d-flex align-items-center justify-content-center fs-5">
              Processing...
            </div>
          )}

          <div
            className="d-flex align-items-center justify-content-center mt-3 ff text-decoration-underline fw-semibold text-orange fs-6 cursor-pointer"
            onClick={() => {
              const link = document.createElement("a");
              link.href = `${alias}/sample_questions_import.csv`;
              link.download = "sample_questions_import.csv";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Download Sample CSV File
          </div>
        </>
      )}
      <div className="bulk-upload-questions-list">
        {successMessage && (
          <div className="d-flex align-items-center ff fs-5 mt-3">
            <span className="me-2 d-flex align-items-center">
              {svg.uploadSuccessMessage}
            </span>
            <span className="text-success">{successMessage}</span>
          </div>
        )}

        <div>
          {errorMessage && (
            <div className="d-flex align-items-center ff fs-5">
              <span className="me-2 d-flex align-items-center">
                {svg.uploadErrorMessage}
              </span>
              <span className="text-danger">{errorMessage}</span>
            </div>
          )}

          {errors?.length > 0 && (
            <ul>
              {errors.map((error, index) => (
                <li key={index} className="ff fs-5">
                  {error}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default BulkUploadQuestionsModal;
